'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef } from 'react';
import { ChipsContainerElement } from './elements';
import { InternalProvider } from '../../util';
import { LinkChip } from './LinkChip';
import { useHorizontalScroll } from './useHorizontalScroll';
export const LinkChips = ({
  id,
  className = '',
  size = 'small',
  layout = 'wrap',
  chips = [],
  isSpa = false,
  options = {},
  ...rest
}) => {
  const scrollRef = useRef(null);
  const isMoving = useHorizontalScroll(layout === 'nowrap' ? scrollRef : null);
  const onClickHandler = onClick => event => {
    if (isMoving) {
      event.preventDefault();
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ChipsContainerElement, _extends({
    "data-aui": "chips.link",
    ref: scrollRef,
    id: id,
    tabIndex: -1,
    className: className,
    $layout: layout
  }, rest), chips.map(chip => /*#__PURE__*/React.createElement(LinkChip, _extends({
    key: chip.label
  }, chip, {
    size: size,
    isSpa: isSpa,
    onClick: onClickHandler(chip.onClick),
    edgeItemsMargin: options.edgeItemsMargin
  })))));
};